import React, { Component, useState, useEffect, Fragment } from 'react';
import classNames from 'classnames';
import T from 'i18n-react';

class ModuleGdprCookieSettingsAcceptCookies extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      test:''
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className="gdpr_cookie_settings_accept_cookies">
        <h2>
          {this.props.GDPRAcceptCookiesHeading}
        </h2>
        <div dangerouslySetInnerHTML={{ __html: this.props.GDPRAcceptCookiesBodyText }} className="component-content-editorial gdpr_cookie_settings_accept_cookies__ingress">
        </div>
        <div className="gdpr_cookie_settings_accept_cookies__button-container">
          <button type="button" className="element-button button--solid--secondary wider gdpr_cookie_settings_accept_cookies__button-container__button" onClick={this.props.handleHandleChoicesClicked}>
            {this.props.GDPRAcceptCookiesHandleChoicesButtonText}
          </button>
          <button type="button" className="element-button button--solid--primary wider gdpr_cookie_settings_accept_cookies__button-container__button" onClick={() => this.props.setGDPRCookieValueHandler(this.props.defaultGDPRCookieValue)}>
            {this.props.GDPRAcceptCookiesAcceptButtonText}
          </button>
        </div>
      </div>
    );
  }
}
export default ModuleGdprCookieSettingsAcceptCookies;
